import type { VoidFunctionComponent } from 'react';

import PackageLabelBadge from './PackageLabelBadge';
import DynamicShowMoreList from '../../generic/DynamicShowMoreList';
import styles from './PackageLabelsList.module.less';
import { sortPackageLabelsByScopeAndName } from './utils';
import type Locator from '../../../../shared/Locator';
import type { PackageLabelAssignmentWithName } from '../../../../shared/model-typings/packagelabelassignment';

type Props = {
  labels?: PackageLabelAssignmentWithName[];
  dependencyVersion?: string;
  dependencyLocator?: Locator;
};

/**
 * Horizontal list of package label badges with dynamic "show more" behavior.
 */
const PackageLabelsList: VoidFunctionComponent<Props> = ({ labels, dependencyVersion, dependencyLocator }) => {
  // If the dependency version is not set, use the locator revision value
  const versionToCheck = dependencyVersion || dependencyLocator?.revision.value;
  const filteredLabels = labels?.filter(
    (label) => label.packageVersion === versionToCheck || label.packageVersion == null,
  );

  if (!filteredLabels?.length) {
    return null;
  }

  const badges = sortPackageLabelsByScopeAndName(filteredLabels).map((label) => {
    return <PackageLabelBadge label={label} />;
  });

  return (
    <div className={styles.packageLabelsList}>
      <DynamicShowMoreList list={['Labels ', ...badges]} lineHeight={27} />
    </div>
  );
};

export default PackageLabelsList;
